class ZasuwaEditsReels {
  constructor(section) {
    this.section = section;
    this.sectionWrapper = section.closest('.shopify-section');
    this.items = Array.from(section.querySelectorAll('[data-edits-reel-item]'));
    this.videos = this.items.map((item) => item.querySelector('video')).filter(Boolean);
    this.activeIndex = Math.max(
      0,
      this.items.findIndex((item) => item.classList.contains('is-active'))
    );
    this.touchStartY = 0;
    this.lastSwitchAt = 0;
    this.switchDelay = 520;

    this.onWheel = this.onWheel.bind(this);
    this.onTouchStart = this.onTouchStart.bind(this);
    this.onTouchEnd = this.onTouchEnd.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);

    this.sectionWrapper?.classList.add('edits-reels-section');
    this.setActive(this.activeIndex, false);
  }

  get isReady() {
    return this.items.length > 0;
  }

  get isModeActive() {
    return document.body.classList.contains('is-edits-mode');
  }

  connect() {
    window.addEventListener('wheel', this.onWheel, { passive: false });
    window.addEventListener('touchstart', this.onTouchStart, { passive: true });
    window.addEventListener('touchend', this.onTouchEnd, { passive: true });
    window.addEventListener('keydown', this.onKeyDown);
  }

  disconnect() {
    window.removeEventListener('wheel', this.onWheel);
    window.removeEventListener('touchstart', this.onTouchStart);
    window.removeEventListener('touchend', this.onTouchEnd);
    window.removeEventListener('keydown', this.onKeyDown);
    this.pauseAll();
  }

  setActive(index, shouldPlay = true, resetActive = false) {
    if (!this.items.length) return;

    const nextIndex = (index + this.items.length) % this.items.length;
    this.activeIndex = nextIndex;

    this.items.forEach((item, itemIndex) => {
      const isActive = itemIndex === nextIndex;
      const video = item.querySelector('video');

      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-hidden', isActive ? 'false' : 'true');

      if (!video) return;

      if (isActive && shouldPlay && this.isModeActive) {
        video.muted = true;
        if (resetActive) video.currentTime = 0;
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });
  }

  pauseAll() {
    this.videos.forEach((video) => video.pause());
  }

  playActive(resetActive = false) {
    this.setActive(this.activeIndex, true, resetActive);
  }

  switchBy(direction) {
    const now = Date.now();
    if (now - this.lastSwitchAt < this.switchDelay) return;

    this.lastSwitchAt = now;
    this.setActive(this.activeIndex + direction, true, true);
  }

  onWheel(event) {
    if (!this.isModeActive || this.items.length < 2) return;

    event.preventDefault();

    if (Math.abs(event.deltaY) < 24) return;
    this.switchBy(event.deltaY > 0 ? 1 : -1);
  }

  onTouchStart(event) {
    if (!this.isModeActive || !event.changedTouches.length) return;
    this.touchStartY = event.changedTouches[0].clientY;
  }

  onTouchEnd(event) {
    if (!this.isModeActive || this.items.length < 2 || !event.changedTouches.length) return;

    const touchEndY = event.changedTouches[0].clientY;
    const deltaY = this.touchStartY - touchEndY;

    if (Math.abs(deltaY) < 42) return;
    this.switchBy(deltaY > 0 ? 1 : -1);
  }

  onKeyDown(event) {
    if (!this.isModeActive) return;

    if (event.key === 'Escape') {
      history.pushState('', document.title, `${location.pathname}${location.search}`);
      window.dispatchEvent(new HashChangeEvent('hashchange'));
      return;
    }

    if (this.items.length < 2) return;

    if (event.key === 'ArrowDown') {
      event.preventDefault();
      this.switchBy(1);
    }

    if (event.key === 'ArrowUp') {
      event.preventDefault();
      this.switchBy(-1);
    }
  }
}

(() => {
  let controllers = [];

  const getReadySections = () =>
    Array.from(document.querySelectorAll('.custom-edits-reels[data-edits-reels-ready="true"]'));

  const syncMode = () => {
    const hasReadyReels = controllers.some((controller) => controller.isReady);
    const wasEditsMode = document.body.classList.contains('is-edits-mode');
    const isEditsMode = hasReadyReels && location.hash === '#edits';

    document.body.classList.toggle('has-edits-reels', hasReadyReels);
    document.body.classList.toggle('is-edits-mode', isEditsMode);

    controllers.forEach((controller) => {
      if (isEditsMode) {
        controller.playActive(!wasEditsMode);
      } else {
        controller.pauseAll();
      }
    });

    if (isEditsMode) {
      window.requestAnimationFrame(() => window.scrollTo(0, 0));
    }
  };

  const init = () => {
    controllers.forEach((controller) => controller.disconnect());
    controllers = getReadySections().map((section) => new ZasuwaEditsReels(section));
    controllers.forEach((controller) => controller.connect());
    syncMode();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  window.addEventListener('hashchange', syncMode);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', init);
})();
